import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="w-full pt-16 pb-12 sm:pt-24 sm:pb-16 px-4" data-id="element-189">
      <div className="max-w-article mx-auto text-center" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-191">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-medium leading-[1.1] text-forest mb-6" data-id="element-192">
            Why Your Gut Pain Keeps Coming Back — And What Nobody Has Told You.
          </h1>
          <p className="font-serif italic text-2xl sm:text-3xl text-ink/70 leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-193">
            And here's what finally stops it.
          </p>
          <div className="flex items-center justify-center space-x-2 text-sm text-ink/60 mb-12" data-id="element-194">
            <span data-id="element-195">By the Rylte Research Team</span>
            <span data-id="element-196">·</span>
            <span data-id="element-197">12 min read</span>
          </div>
        </motion.div>
      </div>

      <motion.div className="max-w-5xl mx-auto w-full rounded-2xl overflow-hidden shadow-sm" initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} data-id="element-198">
        <img src="https://cdn.magicpatterns.com/uploads/qUEMggZaF36jd1jT2FCziD/hf_20260525_114436_9bb0831e-07e8-4524-a4a9-c110bb7bbdad_(1).png" alt="Woman in a sunlit kitchen wincing and clutching her stomach in pain while preparing food on the counter behind her" className="w-full h-[400px] sm:h-[500px] md:h-[600px] object-cover object-center" data-id="element-199" />
      </motion.div>
    </section>;
}